import { map } from 'rxjs/operators';
import { environment } from '../../../../../../../environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Injectable, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { customerInterface } from 'src/app/util/interfaces/customer';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { customAlertInterface } from 'src/app/util/interfaces/customAlert';

@Injectable({
	providedIn: 'root',
})
export class CmdbAlertService {
	private customerURL = environment.baseApiUrl + 'enduser/customers';
	private getAvailableCiTypesUrl = environment.baseApiUrl + 'customAlerts/assetType';
	private postRegisterCustomAlertsUrl = environment.baseApiUrl + 'customAlerts';
	private getCustomAlertUrl = environment.baseApiUrl + 'customAlerts/{id}';
	private putCustomAlertUrl = environment.baseApiUrl + 'customAlerts/{id}';
	private searchCustomAlertsUrl = environment.baseApiUrl + 'customAlerts/search?{querystring}';
	private deleteCustomAlertsUrl = environment.baseApiUrl + 'customAlerts/{id}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private profileService: ProfileService
	) {}

	/*getCustomer(): Observable<customerInterface[]> {
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.AuthLoginService.getSessionToken(), 'Content-Type': 'application/json;charset=UTF-8' });
    return this.http.get<any[]>(this.customerURL, { headers: headers }).pipe(
      map(customerRes => {
        let customerArray: customerInterface[] = [];
        customerRes.forEach(customer => {
          let newCustomer: customerInterface = {
            "id": customer.id,
            "name": customer.name,
          }
          customerArray.push(newCustomer);
        });
        return customerArray;
      })
    )
  }*/

	getAvailableCiTypes(): Observable<ciTypesInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.http.get<any[]>(this.getAvailableCiTypesUrl, { headers: headers }).pipe(
			map((ciTypesRes) => {
				const newCiTypesArray: ciTypesInterface[] = [];
				for (const ciType of ciTypesRes) {
					const newCiType: ciTypesInterface = {
						id: ciType.id,
						label: ciType.label,
						type: ciType.type,
						icon: ciType.icon,
					};
					newCiTypesArray.push(newCiType);
				}
				return newCiTypesArray;
			})
		);
	}

	searchCustomAlert(selectedCiType?: string, emailField?: string): Observable<customAlertInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let querystring = '';

		if (selectedCiType != '') {
			querystring += '&asset_type=' + selectedCiType;
		}
		if (emailField) {
			querystring += '&email=' + emailField;
		}
		const searchCustomAlertsUrl = this.searchCustomAlertsUrl.replace('{querystring}', querystring);
		this.http.get<any[]>(searchCustomAlertsUrl, { headers: headers }).subscribe();
		return this.http.get<any[]>(searchCustomAlertsUrl, { headers: headers }).pipe(
			map((customAlertRes) => {
				const newCustomAlertArray = [];

				for (const customAlert of customAlertRes) {
					const newCustomAlert: customAlertInterface = {
						id: customAlert.id,
						asset_type: customAlert.asset_type,
						email: customAlert.email,
						customer: customAlert.customer,
						hardware: customAlert.hardware,
						software: customAlert.software,
						new_host: customAlert.new_host,
						host_rename: customAlert.host_rename,
						fee: customAlert.fee,
						last_inv: customAlert.last_inv,
						last_inv_days: customAlert.last_inv_days,
						inv: customAlert.inv,
						inv_version: customAlert.inv_version,
						maintence_contracts_expires: customAlert.maintence_contracts_expires,
						maintence_contracts_expires_days: customAlert.maintence_contracts_expires_days,
						lending_expires: customAlert.lending_expires,
						lending_expires_days: customAlert.lending_expires_days,
					};

					newCustomAlertArray.push(newCustomAlert);
				}
				return newCustomAlertArray;
			})
		);
	}
	//registerCustomAlert(customAlert : customAlertInterface, AlertItems: any[],AlertItemsInv: any[],AlertItemsLastInv: any[],AlertItemsConsumable: any[], AlertItemsContract: any[]): Observable<any> {
	registerCustomAlert(customAlert: customAlertInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			/*"customer": parseInt(customAlert.customer.toString()),*/
			asset_type: `${customAlert.asset_type}`,
			// "hw": AlertItems[0].isChecked ? 1 : 0,
			// "sw": AlertItems[1].isChecked ? 1 : 0,
			// "new_host": AlertItems[2].isChecked ? 1 : 0,
			// "host_rename": AlertItems[4].isChecked ? 1 : 0,
			email: `${customAlert.email}`,
			/*"email": `${this.ProfileService.userData().email}`,*/
			// "fee": AlertItems[3].isChecked ? 1 : 0,
			// "last_inv": AlertItemsLastInv[0].isChecked ? 1 : 0,
			// "inv": AlertItemsInv[0].isChecked ? 1 : 0,
			last_inv_days: Number.parseInt(customAlert.last_inv),
			inv_version: `${customAlert.inv}`,
			// "maintence_contracts_expires": AlertItemsContract[0].isChecked ? 1 : 0,
			maintence_contracts_expires_days: Number.parseInt(customAlert.maintence_contracts_expires),
			// "lending_expires": AlertItemsConsumable[0].isChecked ? 1 : 0,
			lending_expires_days: Number.parseInt(customAlert.lending_expires),
		};

		return this.http.post<any>(this.postRegisterCustomAlertsUrl, body, { headers: headers });
	}

	getCustomAlert(id: string): Observable<customAlertInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getCustomAlertUrl = this.getCustomAlertUrl.replace('{id}', id);
		return this.http.get<any>(getCustomAlertUrl, { headers: headers }).pipe(
			map((customAlert) => {
				customAlert = customAlert[0];
				const newCustomAlert: customAlertInterface = {
					id: customAlert.id,
					asset_type: customAlert.asset_type,
					email: customAlert.email,
					customer: customAlert.customer,
					hardware: customAlert.hw,
					software: customAlert.sw,
					new_host: customAlert.new_host,
					host_rename: customAlert.host_rename,
					fee: customAlert.fee,
					last_inv: customAlert.last_inv,
					last_inv_days: customAlert.last_inv_days,
					inv: customAlert.inv,
					inv_version: customAlert.inv_version,
					maintence_contracts_expires: customAlert.maintence_contracts_expires,
					maintence_contracts_expires_days: customAlert.maintence_contracts_expires_days,
					lending_expires: customAlert.lending_expires,
					lending_expires_days: customAlert.lending_expires_days,
				};

				return newCustomAlert;
			})
		);
	}

	updateCustomAlert(
		customAlert: customAlertInterface,
		AlertItems: any[],
		AlertItemsInv: any[],
		AlertItemsLastInv: any[],
		AlertItemsConsumable: any[],
		AlertItemsContract: any[]
	): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putCustomAlertUrl = this.putCustomAlertUrl.replace('{id}', customAlert.id);
		const body = {
			customer: Number.parseInt(customAlert.customer.toString()),
			asset_type: `${customAlert.asset_type}`,
			hw: AlertItems[0].isChecked ? 1 : 0,
			sw: AlertItems[1].isChecked ? 1 : 0,
			new_host: AlertItems[2].isChecked ? 1 : 0,
			host_rename: AlertItems[4].isChecked ? 1 : 0,
			email: `${customAlert.email}`,
			/*"email": `${this.ProfileService.userData().email}`,*/
			fee: AlertItems[3].isChecked ? 1 : 0,
			last_inv: AlertItemsLastInv[0].isChecked ? 1 : 0,
			inv: AlertItemsInv[0].isChecked ? 1 : 0,
			last_inv_days: Number.parseInt(customAlert.last_inv),
			inv_version: `${customAlert.inv}`,
			maintence_contracts_expires: AlertItemsContract[0].isChecked ? 1 : 0,
			maintence_contracts_expires_days: Number.parseInt(customAlert.maintence_contracts_expires),
			lending_expires: AlertItemsConsumable[0].isChecked ? 1 : 0,
			lending_expires_days: Number.parseInt(customAlert.lending_expires),
		};
		return this.http.put<any>(putCustomAlertUrl, body, { headers: headers });
	}

	deleteCustom(id: string): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteCustomAlertsUrl = this.deleteCustomAlertsUrl.replace('{id}', id);
		return this.http.delete<any[]>(deleteCustomAlertsUrl, { headers: headers });
	}
}
